.popover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.backdrop {
  background-color: #000;
  opacity: 0.4;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.modal {
  font-family: 'Inter';
  color: var(--aha-gray-900);
  position: relative;
  border-radius: 8px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.3);
  background-color: var(--theme-primary-background);
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  overflow: hidden;
  z-index: 2;

  aha-modal-header {
    cursor: auto;
  }
}
